import _ from "lodash"

import {
    LICENCE_OWNER_LIKE_USER_TYPES,
    PRACTITIONER_LIKE_USER_TYPES,
    USER_TYPE_PRACTITIONER_LICENCE_OWNER,
    USER_TYPE_ADMIN,
    USER_TYPE_LICENCE_ADMIN,
    USER_TYPE_LICENCE_OWNER,
    USER_TYPE_MANAGER,
    USER_TYPE_PRACTITIONER,
    USER_TYPE_RECEIPTS,
    USER_TYPE_SUPERADMIN,
    USER_TYPE_CLIENT
} from "../constants/userConstants"
import moduleNavAclHelp from "../lib/moduleNavAclHelp"
import { getClinicModeFlags } from "../config/clinicMode"

const WELLNESS_BLOCKED_MENU_IDS = [
    'ordersRoot',
    'orders',
    'order',
    'purchaseorders',
    'purchaseOrder',
    'treatments',
    'treatmentConsumables',
    'treatmentUsage',
    'treatmentUsageDetail',
    'inventory',
    'inventoryAdjustments',
    'lowStockList'
]

const isBlockedInWellness = (id) => {
    if (!id) return false
    return WELLNESS_BLOCKED_MENU_IDS.includes(String(id))
}

export default {
    checkItemAllow(sessionUser, path, memberAcls = []) {
        const { isWellnessEffective } = getClinicModeFlags()
        if (isWellnessEffective && isBlockedInWellness(path)) {
            return false
        }
        if (_.includes([USER_TYPE_SUPERADMIN], sessionUser?.typeId)) {
            const excludeList = ['wageBoard', 'timesheetBoard', 'commissionBoard', 'licenceBoard', 'wageSummaryBoard', 'clientSchedule', 'clientBooking']
            if (_.includes(excludeList, path)) {
                return false
            }
            return true
        }
        // for all member
        switch (path) {
            case 'help':
            case 'booking':
            case 'general':
            case 'public':
            case 'logout':
            case '404':
                return true
        }
        if (sessionUser?.typeId === USER_TYPE_CLIENT) {
            return path === 'clientSchedule' || path === 'clientBooking' || path === 'clientSettings'
        }

        let allowList = []
        switch (path) {
            case 'clientSchedule':
            case 'clientBooking':
            case 'clientSettings':
                // client-only page
                allowList = [
                    USER_TYPE_CLIENT
                ]
                break
            case 'dashboard':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'schedule':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES,
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'appointment':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'rooms':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    USER_TYPE_ADMIN
                ]
                break
            case 'insuranceSchedule':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    ...LICENCE_OWNER_LIKE_USER_TYPES,
                    USER_TYPE_LICENCE_ADMIN
                ]
                break
            case 'licenceSchedule':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    ...LICENCE_OWNER_LIKE_USER_TYPES,
                    USER_TYPE_LICENCE_ADMIN
                ]
                break

            case 'bills':
            case 'bill':
            case 'credits':
            case 'credit':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'receipts':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'receipt':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'orders':
            case 'order':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'licences':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'licenceBoard':
                allowList = [
                    ...LICENCE_OWNER_LIKE_USER_TYPES,
                    USER_TYPE_LICENCE_ADMIN
                ]
                break
            case 'outstanding':
            case 'clients':
            case 'client':
            case 'users':
            case 'user':
            case 'licence':
            case 'categories':
            case 'category':
            case 'subCategories':
            case 'products':
            case 'product':
            case 'billHistory':
            case 'orderHistory':
            case 'paymentHistory':
            case 'creditHistory':
            case 'familyCreditSessionHistory':
            case 'treatmentHistory':
            case 'receiptHistory':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            // case 'commission':
            // case 'wages':
            //     allowList = [
            //         USER_TYPE_RECEIPTS,
            //         USER_TYPE_MANAGER
            //     ]
            //     break
            // case 'wage':
            //     allowList = [
            //         USER_TYPE_RECEIPTS,
            //         USER_TYPE_MANAGER
            //     ]
            //     break
            case 'wageBoard':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES
                ]
                break
            case 'wageSummaryBoard':
            case 'wageSummaryDetail':
            case 'WageSummaryDetail':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES,
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'timesheets':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'timesheetBoard':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES
                ]
                break
            case 'commissionBoard':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES
                ]
                break
            case 'timesheet':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'cashAccounting':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'cardAccounting':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break    
            case 'insuranceAccounting':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'ownerGrowthEngine':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES,
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    USER_TYPE_ADMIN
                ]
                break
            // case 'managerZone':
            //     allowList = [
            //         USER_TYPE_MANAGER
            //     ]
            //     break
            // case 'practitioner':
            //     allowList = [
            //         USER_TYPE_PRACTITIONER,
            //         USER_TYPE_RECEIPTS
            //     ]
            //     break
            // case 'systemSettingCreditType':
            case 'systemSettingScheduleSort':
            case 'clinicRuntimeSetting':
            case 'systemSettingUserPermission':
                allowList = [
                    USER_TYPE_MANAGER
                ]
                break
        }
        if (sessionUser?.typeId) {
            if (_.includes(allowList, sessionUser.typeId)) {
                return true
            } else {
                const customNavPermit = moduleNavAclHelp.checkMemberPathAcl(sessionUser, path, memberAcls)
                return customNavPermit
            }
        } else {
            return false
        }
    },
    checkGroupAllow(sessionUser, menu, memberAcls) {
        const { isWellnessEffective } = getClinicModeFlags()
        if (isWellnessEffective && isBlockedInWellness(menu?.id)) {
            return false
        }
        if (sessionUser?.typeId === USER_TYPE_SUPERADMIN) {
            return true
        }
        const whiteList = ['logoutRoot', 'guideRoot']
        if (_.includes(whiteList, menu.id)) {
            return true
        }
        let allowList = []
        switch (menu.id) {
            case 'dashboardRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'appointmentsRoot':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES,
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    USER_TYPE_ADMIN,
                    USER_TYPE_CLIENT
                ]
                break
            case 'financesRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'ordersRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'licenceRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER,
                    ...LICENCE_OWNER_LIKE_USER_TYPES,
                    USER_TYPE_LICENCE_ADMIN
                ]
                break
            case 'clientHistoryRoot':
            case 'clientRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'servicesRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'staffRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'wagesRoot':
                allowList = [
                    ...PRACTITIONER_LIKE_USER_TYPES,
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
            case 'receptionistZoneRoot':
            case 'SystemSettingRoot':
                allowList = [
                    USER_TYPE_MANAGER
                ]
                break
        }
        if (sessionUser?.typeId) {
            if (_.includes(allowList, sessionUser.typeId)) {
                return true
            } else {
                const customNavPermit = moduleNavAclHelp.checkMemberPathAcl(sessionUser, menu.id, memberAcls)
                return customNavPermit
            }
        } else {
            return false
        }
    },

    checkCollapseAllow(sessionUser, menu) {
        if (sessionUser?.typeId === USER_TYPE_SUPERADMIN) {
            return true
        }
        let allowList = []
        switch (menu.id) {
            case 'clientHistoryRoot':
                allowList = [
                    USER_TYPE_RECEIPTS,
                    USER_TYPE_MANAGER
                ]
                break
        }
        if (sessionUser?.typeId) {
            if (_.includes(allowList, sessionUser.typeId)) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    },

    async defaultLandingPage(sessionUser) {
        let home = '/dashboard'
        switch (sessionUser?.typeId) {
            case USER_TYPE_MANAGER:
            case USER_TYPE_SUPERADMIN:
            case USER_TYPE_PRACTITIONER:
            case USER_TYPE_PRACTITIONER_LICENCE_OWNER:
                home = '/schedule'
                break
            case USER_TYPE_ADMIN:
                home = '/receipts'
                break
            case USER_TYPE_LICENCE_OWNER: {
                home = '/licenceBoard'
                break
            }
            case USER_TYPE_CLIENT:
                home = '/clientBooking'
                break

            case USER_TYPE_LICENCE_ADMIN:
                home = '/licenceBoard'
            
        }
        return home
    }
}

